// TODO: the ground truth match with index to display marked, so different tokenized versions with
// different tokens order can mess up the mark.
import { FixMe } from '../types/util';
import { IToken } from '../types/my-types';

interface Token {
  id?: string;
  phrase_id?: number;
  content: string;
  bounding_box: any;
  children_token_indices: number[];
}

export const makePage = (fileId: string, docId: string, docJson: FixMe, pageNumber: string) => {
  const pageInt = parseInt(pageNumber, 10);
  const id = fileId + pageNumber;

  let tokenCount = 0;
  const pageTokens: IToken[] = docJson[pageNumber].tokens?.map((t: Token) => {
    return {
      id: `${pageNumber}-${tokenCount}`,
      index: tokenCount++,
      page: pageInt,
      content: t.content,
      bbox: t.bounding_box,
    };
  });

  let phraseCount = 0;
  const pagePhrases: IToken[] = docJson[pageNumber].phrases?.map((t: Token) => {
    let phrase: IToken = {
      id: `${pageNumber}-${phraseCount}`,
      index: phraseCount++,
      page: pageInt,
      content: t.content,
      bbox: t.bounding_box,
      children: t.children_token_indices,
    };
    t.children_token_indices?.forEach((child, index) => {
      pageTokens[child].parent = phrase;
      pageTokens[child].parent_index = index;
    });
    return phrase;
  });

  let subPhrases: Token[] = docJson[pageNumber].subphrases;
  let result: Token[][] = pagePhrases?.map((t: IToken, ti: number) => {
    return [];
  });
  subPhrases?.forEach((t, ti) => {
    if (t.phrase_id !== undefined) {
      result[t.phrase_id].push(t);
    }
  });

  let subPhraseCount = 0;
  const pageSubPhrases: IToken[][] = result?.map((s: Token[], si: number) => {
    let phraseLength = pagePhrases[si].children?.length;
    let containsFullPhrase = false;
    let nested = s.map((t: Token, ti: number) => {
      if (t.children_token_indices.length === phraseLength) containsFullPhrase = true;
      return {
        id: `${pageNumber}-${subPhraseCount}`,
        index: subPhraseCount++,
        page: pageInt,
        phrase_id: t.phrase_id,
        children: t.children_token_indices,
        content: t.content,
        bbox: t.bounding_box,
      };
    });
    if (!containsFullPhrase) {
      let fullPhrase = JSON.parse(JSON.stringify(pagePhrases[si]));
      nested.push({
        ...fullPhrase,
        id: `${pageNumber}-${subPhraseCount}`,
        index: subPhraseCount++,
        phrase_id: si,
      });
      pagePhrases[si].children?.forEach((c: number, ci: number) => {
        let t: IToken = pageTokens[c];
        nested.push({
          id: `${pageNumber}-${subPhraseCount}`,
          index: subPhraseCount++,
          page: pageInt,
          phrase_id: si,
          children: [t.index],
          content: t.content,
          bbox: t.bbox,
        });
      });
    }
    return nested;
  });

  return {
    id,
    docId: docId,
    pageNumber: pageInt,
    pageWidth: docJson[pageNumber].page_size ? docJson[pageNumber].page_size.width : null, // Backward compatibility with older tokenized.json
    pageHeight: docJson[pageNumber].page_size ? docJson[pageNumber].page_size.height : null, // Backward compatibility with older tokenized.json
    pageBoundingWidth: docJson[pageNumber].full_page_bounding_box[2].x,
    pageBoundingHeight: docJson[pageNumber].full_page_bounding_box[2].y,
    pageTokens: pageTokens,
    pagePhrases: pagePhrases,
    pageSubPhrases: pageSubPhrases,
  };
};
